export var MISSING_CATEGORY_AND_ACTION = 'Category and action must be specified';
export var FIELD_HAS_ERRORS = 'This field has errors';
export var FIELD_IS_REQUIRED = 'This field is required';
export var FIELD_DOES_NOT_MATCH = 'This field doesn\'t match another field';
export var JSON_INVALID = 'Could not parse JSON';
export var COUNTRY_NOT_FOUND = 'Country not found';
export var REQUIRED_ELEMENTS_NOT_FOUND = 'Could not find all required elements';
export var CLIPBOARD_UNSUPPORTED = 'Clipboard is not supported';
